import { Component,OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Title} from '@angular/platform-browser';


import { PostService } from '../../services/firebase/post.service';
import { ImageService } from '../../services/firebase/image.service';
import { UrlAttachmentService } from '../../services/firebase/url_attachment.service';

import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as _ from 'lodash';
import {map} from 'rxjs/operators';

import { Post,User } from '../../models/models';

import { LoadingBarService } from '@ngx-loading-bar/core';
import { MessagingService } from '../../services/notifications/messaging';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  styleUrls: ['./home.scss']

})

export class HomePage implements OnInit {

	feed:Array<any> = [];
	first:number;
	last:number=15;
	empty:boolean;
	user;

	
  
	constructor(private route: ActivatedRoute,
		private router: Router,
		private postService:PostService,
		private image:ImageService,
		private url_attachment:UrlAttachmentService,
		private afAuth: AngularFireAuth,
		private loadingBar: LoadingBarService,
		private msgService: MessagingService,
		private _titleService:Title) { }

	ngOnInit(){
	  	this._titleService.setTitle("Microblog Felipe Mateus");

		this.getPostsList();
		this.afAuth.auth.onAuthStateChanged((user)=> {
			if(user) {
				this.user = user;
			}
		});
	} 
	
	doInfinite(infiniteScroll) {
		this.getPostsList(infiniteScroll);	
	}

	goToPagePost(post){
		this.router.navigate(['/post', post.key ]);
	}
	
	
	getPostsList(infiniteScroll=null){
		this.loadingBar.start();

		this.postService.getPostList(this.first,this.last).snapshotChanges().pipe(
			map(data => {
				//iniciar Variaveis
				let first = _.last(data);
				let newPosts;
				
				
				if(!this.feed.length){
					 newPosts = _.slice(data, 0, this.last);
				}else{
					 newPosts = _.slice(data, 1, this.last);
				}
				
				//Verificar se esta vazio
				if ( !data.length) {
					this.empty = true;
					this.loadingBar.complete();
					return ;
				}
				//Atualizar o ultimo da lista
				this.first = (first.payload.doc.data() as Post).timestamp;
				
				
			
				//Adionar lista ao feed
				if (newPosts) {
					newPosts.map(todoSnap => {
						//Pegar informações do posts
						let post = todoSnap.payload.doc.data();
						
						post.key = todoSnap.payload.doc.id;
						post.url_attachment = this.url_attachment.getUrlAttachment(post.url_attachment_id).valueChanges();
						post.url_attachment.subscribe(url=>{
							if(!url) return ;
							post.url_attachment.img = this.image.getImage(url.image_id).valueChanges();
						});
						 
						//Adicionar Feed
						this.feed.push(post);
						this.loadingBar.complete();
						return ;
					})
				}
			})
		).subscribe();
		
	}
	writePost(){
		this.router.navigate(['/write']);
	}
	subscribeNotifications(){
		this.msgService.getPermission()
	}
	
	isSubscribe():boolean{
		return (localStorage.getItem('fcm_keyToken')!==null);
	}
}